import React from 'react';
import Typography from 'Components/DesignSystem/Typography/Typography';

type StatsPill = {
    // string allows a placeholder (e.g. "…") while a count is still loading
    count: number | string;
    label: string;
};

type StatsPillsSectionProps = {
    title: string;
    pills: StatsPill[];
    className?: string;
};

const StatsPills = ({ title, pills, className }: StatsPillsSectionProps) => {
    return (
        <div className={className} data-testid="stats-pills-section">
            <Typography variant="title-header" as="h2" className="tw-text-ink tw-mt-3 tw-mb-2">
                {title}
            </Typography>
            <div className="tw-inline-flex tw-justify-start tw-items-center tw-gap-3">
                {pills.map((pill, index) => (
                    <div
                        key={`${pill.label}-${index}`}
                        className="tw-px-4 tw-py-1 tw-bg-surface-sunken tw-rounded-2xl tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-edge tw-flex tw-justify-start tw-items-center tw-gap-1.5"
                        data-testid={`stats-pill-${index}`}
                    >
                        <div className="tw-flex tw-justify-start tw-text-ink tw-text-sm tw-font-semibold">
                            {pill.count}
                        </div>
                        <div className="tw-flex tw-justify-start tw-text-ink tw-text-xs tw-font-normal">
                            {pill.label}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StatsPills;